import React, {useEffect, useState} from 'react'
import {Col, Row} from 'antd'
import PropTypes from 'prop-types'
import {connect} from 'react-redux'
//Components
import {TableDetail, RowTableDetail} from "../../Common/View/TableViewDetail";
// Constant
import typo from '../../../constants/dictionaries'
import Api from "../../../api";
import Message from "../../Messages";
import helper from '../../../helper/helper'

const DN = ({data, user}) => {

  const {
    doanhNghiep_DiaChi,
    doanhNghiep_Ten,
  } = data || {};

  return (
    <Row>
      <TableDetail>
        <RowTableDetail title={typo.cscore_license_organization}>{doanhNghiep_Ten}</RowTableDetail>
        <RowTableDetail title="Địa chỉ">{doanhNghiep_DiaChi}</RowTableDetail>
      </TableDetail>
    </Row>
  )
};

DN.propTypes = {
  data: PropTypes.any.isRequired
};

const mapStateToProps = (state) => ({
  user: state.oidc.user
});

export default connect(mapStateToProps)(DN)